export const advisorData = [
  {
    imageUrl: require("../assets/advisor/CSE HOD.png"),
    name: "NIHAR RANJAN PANDA",
    designation: "HOD,CSE",
    content:
      "The Calling of the humanities is to make us truly human in the best sense of the word",
  },
  {
    imageUrl: require("../assets/advisor/CIVIL HOD.png"),
    name: "SACHI KANTA PRADHAN",
    designation: "HOD, CIVIL",
    content: "The science of today is the technology of tomorrow. ",
  },
  {
    imageUrl: require("../assets/advisor/MECH HOD.png"),
    name: "PINAK BHUSAN DASH",
    designation: "HOD, MECHANICAL",
    content:
      "Research is to see what everybody else has seen, and to think what nobody else has thought",
  },
  //   {
  //     imageUrl: require("../assets/advisor/bk.nayak.jpeg"),
  //     name: "Prof. (Dr.) B.K. Nayak",
  //     designation: "Dept. of Social Work",
  //     content:
  //       "The best way to find yourself is to lose yourself in the service of others.",
  //   },
];
